// @noflow
import { httpPost } from '../../helpers/helpers.api';

export default function changePassword(newPassword, oldPassword, id) {
    return httpPost(
        'user/' + id + '/set-password',
        {
            password: newPassword,
            oldPassword: oldPassword
        },
        true
    );
}



// WEBPACK FOOTER //
// ./src/core/api/authentication/change-password/index.js